<template>
  <div class="content-page">
    <div class="tab-header">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>{{ pageTitle }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="tab-content">
      <el-form
        ref="singleUserFuncInfoForm"
        :model="singleUserFuncInfoForm"
        :rules="singleUserFuncInfoRules"
        label-width="120px"
      >
        <el-form-item label="是否开启">
          <el-switch
            size="small"
            v-model="singleUserFuncInfoForm.userFuncStatus"
            active-text="开启"
            inactive-text="关闭"
            :active-value="30"
            :inactive-value="10"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="说明：" prop="activityName">
          <div v-html="userFuncIllustrate"></div>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="submit">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { modifyUserFuncInfo, singleUserFuncInfo } from "../api/index";
export default {
  data() {
    return {
      singleUserFuncInfoForm: {
        userFuncType: this.userFuncType(),
        userFuncStatus: 10,
      },
      singleUserFuncInfoRules: {},
      currentCoupon: {},
      memberCardList: [],
    };
  },
  computed: {
    pageTitle() {
      if (this.$route.path == "/devicemanage/moneyCodeMemberPay") {
        return "收款码会员买单";
      } else if (this.$route.path == "/devicemanage/moneyCodeCloudSoundNoPay") {
        return "云音响防逃单";
      }
    },
    userFuncIllustrate() {
      if (this.$route.path == "/devicemanage/moneyCodeMemberPay") {
        return `1. 需要开通会员功能<br>
2. 会员功能需要一张投放领取的模板卡<br>
3. 所有门店的收款码会员买单在此统一开启或关闭`;
      } else if (this.$route.path == "/devicemanage/moneyCodeCloudSoundNoPay") {
        return `1. 对支持防逃单功能的云音响生效。<br>
2. 所有门店的云音响防逃单在此统一开启或关闭`;
      }
    },
  },
  components: {},
  mounted() {
    this.singleUserFuncInfo();
  },
  methods: {
    userFuncType() {
      if (this.$route.path == "/devicemanage/moneyCodeMemberPay") {
        return 11;
      } else if (this.$route.path == "/devicemanage/moneyCodeCloudSoundNoPay") {
        return 13;
      }
    },
    singleUserFuncInfo() {
      singleUserFuncInfo({
        userFuncType: this.userFuncType(),
      }).then((res) => {
        if (res.code == 1) {
          Object.assign(this.singleUserFuncInfoForm, res.data);
        }
      });
    },
    submit() {
      this.$refs.singleUserFuncInfoForm.validate((valid) => {
        if (!valid) {
          this.$notify({
            title: "提示",
            message: "请输入相应信息",
            type: "warning",
            duration: 1000,
          });
          return;
        } else {
          let params = JSON.parse(JSON.stringify(this.singleUserFuncInfoForm));
          modifyUserFuncInfo(params).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: `修改成功`,
                type: "success",
                duration: 1000,
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "warning",
                duration: 1000,
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped></style>
